import { SetOrganizationContainer } from "./container";

export const SetOrganizationPage = () => {
  return <SetOrganizationContainer navigateWhenFinished={() => {}} />;
};
